export default "__VITE_ASSET__65e5c062__"